import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useRouteMatch } from "react-router-dom";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import {
  createStyles,
  Grid,
  Hidden,
  makeStyles,
  Theme,
} from "@material-ui/core";
import GoogleMap from "../../../../components/common/googleMap.tsx";
import {
  ERROR_MESSAGE_UNEXPECTED_ERROR,
  SUCCESSFULLY_UPDATED,
} from "../../../../utils/consts";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import { getObjectDifferences } from "../../../../utils/isDeepEqual";
import {
  getIntegrationConfig,
  getIntegrationsPerLocation,
} from "../../../../services/locationApp/integrationsService";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import IntegrationsInfoNode from "./IntegrationsInfoNode";

export interface BasicInfoProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addressInfoStyle: {
      paddingRight: "12px",
      [theme.breakpoints.down("xs")]: {
        paddingRight: "0px",
      },
    },
    googleMapStyle: {
      paddingLeft: "12px",
      [theme.breakpoints.down("xs")]: {
        paddingLeft: "0px",
        marginTop: "8px",
      },
    },
  }),
);

/* Get all basic information and location information using API call at initial load. */
const Integrations: React.FunctionComponent<BasicInfoProps> = () => {
  const [integrations, setIntegrations] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [integrationConfig, setIntegrationConfig] = useState("");
  const match: any = useRouteMatch();
  const locationId = (match.params as any).locationId;

  const getAllIntegrationsPerLocation = async () => {
    try {
      const response = await getIntegrationsPerLocation(locationId);
      if (response.status === 200) {
        const data = response.data;
        // Handle response whether it's wrapped in { integrations: [...] } or direct array [...]
        const integrationsList = Array.isArray(data)
          ? data
          : data?.integrations || [];

        setIntegrations(integrationsList);
      }
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
    setIsLoading(false);
  };

  const getAllIntegrationConfig = async () => {
    try {
      const response = await getIntegrationConfig(locationId);
      if (response.status === 200) {
        const data = response.data;
        // Handle response whether it's wrapped in { integrations: [...] } or direct array [...]

        setIntegrationConfig(data);
      }
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getAllIntegrationsPerLocation();
  }, []);
  console.log("integrationConfig", integrationConfig);
  const classes = useStyles();
  console.log("integrations", integrations);
  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <IntegrationsInfoNode
        isLoading={isLoading}
        integrations={integrations}
        getAllIntegrationConfig={getAllIntegrationConfig}
      />
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(Integrations, Authorities.BASIC_INFO_READ);
